
import { TVCharBalanceador } from '../../components/TVChartContainer/balanceador';
// import Prices from './Prices';
import { useState,useEffect } from 'react';
import axios from "axios";
import { API_URL } from '../../api-config';
// import ChatComponent from './chat_window';

const Balanceador = () => {
  const token = localStorage.getItem("token");
  const [admin,setAdmin] = useState(false);
  useEffect(() => {
    axios.get(`${API_URL}/users-api/me`, {
        headers: {
            "accept": "application/json",
            "Authorization": "Bearer " + token,
        },
    }).then((response) => {

        let userType = response.data.type;
        if (userType === 'Admin') {
            setAdmin(true);
        } 
    });
}, []);
  return (

    <div className='w-screen h-auto p-8 flex flex-col items-center'>

      {/* <TVCharBalanceador  /> */}
      
      {admin ? 
      <div className=''>
        {/* <ChatComponent/> */}
        <TVCharBalanceador  />

      </div>

      :<div>
      <TVCharBalanceador  />
      {/* <Prices/> */}
      </div>}
      
    </div>
  );
};

export default Balanceador;